"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Monitoring() {
  const image = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const headline = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const caption = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="6822" id="monitoring-solutions-hero" className="bg-background text-foreground font-default">
      <div className="mx-auto max-w-[1440px] px-6 md:px-24 lg:px-32 pt-32 md:pt-44 pb-32 md:pb-44">
        {}
        <div ref={image.ref} className="w-full transition-opacity duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)]" style={{
        opacity: image.isVisible ? 1 : 0
      }}>
          <div className="relative w-full overflow-hidden aspect-[16/9] rounded-lg shadow-xl">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696316/img/industrial_monitoring_systems.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696316/img/industrial_monitoring_systems.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1696316/img/industrial_monitoring_systems.png-wvc-sizes" alt="Industrial monitoring systems — real-time data analytics" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" />
          </div>
        </div>

        {}
        <div className="mt-16 md:mt-20 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          {}
          <div ref={headline.ref} className="lg:col-span-7 transition-all duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)]" style={{
          opacity: headline.isVisible ? 1 : 0,
          transform: headline.isVisible ? "translateY(0)" : "translateY(12px)",
          transitionDelay: "120ms"
        }}>
            <h1 className="font-default text-foreground font-normal leading-[1.02]" style={{
            fontSize: "clamp(2.75rem, 6.4vw, 5.75rem)",
            letterSpacing: "-0.022em"
          }}>
              Precision in{" "}
              <span className="font-serif italic font-normal text-primary" style={{
              letterSpacing: "-0.01em"
            }}>
                every
              </span>{" "}
              measurement.
            </h1>

            
          </div>

          {}
          <div ref={caption.ref} className="lg:col-span-5 lg:pt-6 transition-all duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)]" style={{
          opacity: caption.isVisible ? 1 : 0,
          transform: caption.isVisible ? "translateY(0)" : "translateY(12px)",
          transitionDelay: "240ms"
        }}>
            <div className="h-px w-10 bg-border" />
            <div className="mt-3 font-serif italic text-muted-foreground space-y-1.5 text-[0.8125rem] leading-[1.45]">
              <p>Advanced Diagnostics</p>
              <p>Industrial Monitoring</p>
              <p>Global Standards</p>
              <p>Trusted Technical Solutions</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}